module.exports = __webpack_public_path__ + "img/ab-left_03.da030ea5.jpg";